module.exports = __webpack_public_path__ + "static/media/select-icon.a545fda6.svg";